import { SecurityDepositTableQuery } from 'src/app/shared/shared.model';
import { ProductTypeCode, ApplicationStatusCode } from '../../common/models/application-general.model';
import { Resident, ResidentReference } from "../../residents/models/residents.model";

export class ApplicationsQuery extends SecurityDepositTableQuery<ApplicationQueryParameter> {
  applicationType!: ApplicationTypeCode;
  property?: string;
  apartment?: string;
  tenantName?: string;
  email?: string;
  phone?: string;
  search?: string;
  statusCodes?: ApplicationStatusCode[];
  progressStatusCode?: ApplicationsGroupStatusCode;
  leaseStartDateFrom?: Date;
  leaseStartDateTo?: Date;
  leaseEndDateFrom?: Date;
  leaseEndDateTo?: Date;
  lastInteractionDateFrom?: Date;
  lastInteractionDateTo?: Date;
}

export class Application {
  applicationId!: string;
  status!: string;
  statusCode?: ApplicationStatusCode;
  productTypeCode?: ProductTypeCode;
  declineTypeCode?: ApplicationDeclineTypeCode;
  resident?: ResidentReference;
  updateTimeUtc!: Date;
  leaseTerm!: string;
  isFullPayment!: boolean;
  securityDeposit!: number;
  monthlyRent?: number;
  isApproveAvailable?: boolean;
  isDeclineAvailable?: boolean;
  isCloseAvailable?: boolean;
  declineReason!: string;
  declineType!: string;
  screeningResultCode?: ScreeningResultCode;
}

export class ApplicationDetails {
  id!: string;
  isFullPayment?: boolean;
  statusCode?: ApplicationStatusCode;
  isApproveAvailable?: boolean;
  isDeclineAvailable?: boolean;
  isCloseAvailable?: boolean;
  progressStatusCode?: ProgressStatusCode;
  productTypeCode?: ProductTypeCode;
  declineTypeCode?: ApplicationDeclineTypeCode;
  propertyManagerName!: string;
  propertyManagerAddress!: string;
  incomeLevel!: number;
  createTimeUtc?: Date;
  updateTimeUtc?: Date;
  resident?: Resident;
  address?: ApplicationAddress;
  employmentDetails?: ApplicationEmploymentDetails;
  history?: ApplicationDetailsHistory[];
  files!: ApplicationFile[];
  isCanUpdateApplication?: boolean;
}

export class ApplicationDetailsHistory {
  productTypeCode?: ProductTypeCode;
  statusCode?: ApplicationStatusCode;
  comment?: string;
  createTimeUtc?: Date;
}

export class ApplicationAddress {
  apartment?: string;
  street?: string;
  city?: string;
  state?: string;
  zipCode?: string;
}

export class ApplicationEmploymentDetails {
  incomeLevelCode?: IncomeLevelCode;
  incomeSourceTypeCode?: IncomeSourceTypeCode;
  incomeSourceDescription?: string;
}

export class ApplicationFile {
  typeCode!: FileTypeCode;
  name?: string;
  url?: string;
}

export class UpdateApplication {
  applicationId!: string;
  propertyManagerId?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  apartment?: string;
  leaseTerm?: number;
  monthlyRent?: number;
  securityDeposit?: number;
  moveInDate?: Date;
  endOfLeaseDate?: Date;
}

export class UpdateApplicationApartment {
  applicationId!: string;
  apartment?: string;
}

export enum ApplicationQueryParameter {
  property = 1,
  apartment = 2,
  name = 3,
  status = 4,
  lastInteractionDate = 5,
  leaseStartDate = 6,
  leaseEndDate = 7
}

export enum ApplicationTypeCode {
  processing = 1,
  legacy = 2
}

export enum ApplicationsGroupStatusCode {
  inProgress = 2,
  funded = 9,
  closed = 10
}

export enum ApplicationDeclineTypeCode {
  risk = 1,
  choice = 2
}

export enum IncomeLevelCode {
  from0To15 = 1,
  from15To30 = 2,
  from30To50 = 3,
  from50To75 = 4,
  from75To100 = 5,
  over100 = 6
}

export enum ProgressStatusCode {
  notInvitedYet = 1,
  invited = 2,
  registered = 3,
  inProgress = 4,
  completed = 5,
  sdPendingPmtDetails = 6,
  bondPendingPmtDetails = 7,
  pendingSignature = 8,
  pendingApproval = 9,
  bondSdFundReady = 10,
  sdFunded = 11,
  bondSdFunded = 12,
  sdDeclined = 13,
  declined = 14,
  bondSdDeclined = 15,
  closedNotInterested = 16,
  closedDifferentApartment = 17,
  closedNotResponding = 18,
  bondApproved = 19,
  closedNa = 20,
  closedRefunded = 21,
  leaseEnded = 22,
  contractEnded = 23,
  closedDeclinedByLandlord = 24,
  closedNotAffordable = 25,
  fullSdPendingPmtDetails = 26,
  pendingSdDeployment = 27,
  deployingFunds = 28,
  pendingTenantPlanReview = 29,
  withdrawingTenantFunds = 30,
  closedArchivedByLandlord = 31,
  certificatePendingPmtDetails = 32,
  rentCollection = 33
}

export enum IncomeSourceTypeCode {
  employed = 1,
  student = 2,
  caregiver = 3,
  selfEmployed = 4,
  unemployed = 5,
  other = 6,
  rentVoucher = 7
}

export enum FileTypeCode {
  identityDocument = 1,
  employmentVerificationLetter = 2,
  studentEligibilityCertificate = 3,
  proofOfIncome = 4,
  bankStatement = 5,
  paymentStub = 6,
  w9w8Form = 7,
  contract = 8,
  smartScreening = 9,
  other = 10,
}

export enum ScreeningResultCode {
  noResult = 0,
  passed = 1,
  failed = 2
}

export interface TabItem {
  label: string;
  icon: string;
  route: string;
}